import markUrl from "@/assets/aron-mark.png";

/**
 * Znak ARON-a (owczarek, pixel-art) — rysowany maską CSS, nie zwykłym <img>,
 * żeby zachowywał się dokładnie jak ikona z zestawu: bierze kolor z `text-*`
 * rodzica (`bg-current`), więc ten sam znak jest czerwony na liście rozmów i
 * biały na kaflu awatara. Alfa maski pochodzi z bieli oryginału.
 */
export function AronMark({
  size = 16,
  className = "",
  title,
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return (
    <span
      role="img"
      aria-label={title ?? "ARON"}
      title={title}
      style={{
        width: size,
        height: size,
        WebkitMaskImage: `url(${markUrl})`,
        maskImage: `url(${markUrl})`,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
      className={`inline-block shrink-0 bg-current ${className}`}
    />
  );
}

/**
 * Ten sam znak w wersji na mały kafelek (awatar przy wiadomości, 28 px): pixel-art
 * przy tej wielkości robi się plamą, więc zamiast psa idzie sygnatura „A2.0".
 */
export function AronWordmark({
  className = "text-[9px]",
}: {
  className?: string;
}) {
  return (
    <span
      aria-label="ARON 2.0"
      className={`font-mono font-bold leading-none tracking-[-0.02em] ${className}`}
    >
      A2.0
    </span>
  );
}
